{
  "addIndividualEffort": "Add individual in kind",
  "addIndividually": "Add individually",
  "addSelfEffort": "Add in kind",
  "approveSelfEffort": "Approve in kind",
  "byTotal": "Of a total of {{amount}} NOK",
  "cannotBeAfterDate": "Cannot be after {{ value }}",
  "cannotBeBeforeDate": "Cannot be before {{ value }}",
  "changelog.import.dateHeaderChanged": "The header for the Date-column has been changed, less than 30 days ago. Please change the Date-column header to match the template, or use the new template. ",
  "changelog.import.uspecified": "There has been a change to the template, which is not specified, less than 30 days ago. Please re-download the template to be able to import without errors.",
  "changeMultipleRows": "Here you can change the time and hourly rate for multiple rows of in kind simultaneously.",
  "contactNotSelected": "You must choose contacts",
  "contactSelfEffortIntro": "Here, all in kind is registered with the contact",
  "contactsNotInResourceBase": "These contacts are not in the resource base. Do you want to add them and approve their in kind?",
  "contactsUnsubscribed": "These contacts are unsubscribed from the resource base. Their in kind will not be approved.",
  "couldNotChangeInkind": "Could not change in kind. Please try again.",
  "couldNotCreateInKind": "Could not create in kind. Please try again.",
  "couldNotDelete": "Could not delete in kind. Please try again.",
  "deleteAreYouSure": "Are you sure you want to delete these in kind rows? This action cannot be undone.",
  "deleteSelfEffort": "Delete in kind",
  "downloadTemplate": "Download template",
  "downloadTemplateTip": "To make importing data easier, we recommend that you download our excel-template:",
  "editSelfEffort": "Edit in kind",
  "errorCode.ValidSource": "Source must be either Import, Link or Manual",
  "errorCode.ValidStatus": "Status must be either Counting, Non-Counting or Pending approval",
  "estimatedHoursByHourlyRate": "* estimated {{hours}} hours left with {{hourlyRate}}, - as hourly rate",
  "getFromWorkGroup": "Get from work group",
  "hourlyRateKept": "Original hourly rate will be kept",
  "hoursIsNaN": "Amount of hours and minutes is not valid",
  "hoursNotLessThanZero": "Hours can not be less than zero.",
  "hoursRegistered": "hours registered",
  "ImportedSelfEffort": "Imported in kind.",
  "importInkind": "Import in kind",
  "inkindContactDeleted": "Cannot go to page, this contact is deleted",
  "inkindDateOptional": "In kind date (optional)",
  "inkindMemberDeleted": "Cannot go to page, this company is deleted",
  "inkindOverview": "Inkind overview",
  "inkindReadyToregister_many": "{{ rows }} rows of in kind ready for registration.",
  "inkindReadyToregister_one": "One row of in kind ready for registration.",
  "inkindRegistered_many": "{{ rows }} rows of in kind registered.",
  "inkindRegistered_one": "One row of in kind registered.",
  "inkindUploading": "In kind upload",
  "keepContactHourRate": "Keep the contacts hour rate.",
  "keepOriginalHourRate": "Keep original hourly rate",
  "keepOriginalStatus": "Keep original status",
  "markedRowsAlreadyApproved": "Marked rows is already approved",
  "memberHours": "Members registered hours",
  "memberInKind": "Members inkind",
  "minutesCannoteBeLessThanZero": "Mintes cannot be less than 0",
  "mustSelectEvent": "You must select an event before you can upload in kind.",
  "needsApproval": "Needs approval",
  "newContactsAdded_many": "{{ newContacts }} contacts are not in the resource base and will be added.",
  "newContactsAdded_one": "One contact is not in the resource base and will be added.",
  "newHourlyRate": "New hourly rate will be {{ hourlyRate }}",
  "newMembersAdded_many": "{{ newContacts }} members are not in the resource base and will be added.",
  "newMembersAdded_one": "One member is not in the resource base and will be added.",
  "newStatus": "New in kind status will be {{ status }}",
  "newTime": "New time will be {{ hours }}h {{ minutes }}m.",
  "noContactsSelected": "No contacts selected.",
  "noRowsToUpload": "No in kind rows to upload.",
  "noTimechange": "The original time will be kept.",
  "numberOfApprovedRows_many": "There are {{ approvedNumber }} approved among the in kind rows.",
  "numberOfApprovedRows_one": "There is one approved among the in kind rows.",
  "numberOfContacts": "No. of contacts:",
  "numberOfHours": "Total hours",
  "numberOfMinutes": "Total minutes",
  "participantCompanies": "No. of participants (companies):",
  "regiseredEffortHours": "Regisered hours",
  "registeringError": "Error registering in kind. Click show for details.",
  "registerMultiple": "Register multiple",
  "registerSelfEffort": "Register in kind",
  "registerSingel": "Register singel",
  "removeAll": "Remove all",
  "removeSelectedContact": "Remove selected contact",
  "selectEventHelpText": "A project must be choosen before an event can be selected. If there are no events in the project, you cannot select an event here.",
  "selfEffort": "In kind",
  "selfEffortStatus": "In kind status",
  "sendRegistration": "Send registration",
  "statusKept": "Original status will be kept.",
  "submittingInKind": "Submitting in kind...",
  "totalEffortBasedOnHours": "Total in kind for this project based on registered hours:",
  "totalFromContacts": "Total approved in kind collected from contacts in this project:",
  "totalTimeLessThanZeroHours": "Total time cannot be less than 0 hours"
}
